<script lang="ts">
import FicheContratViewer from '@/generated/fiches/FicheContratViewer.vue';
import { Extended } from '@/framework/base/classes/Schema';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheContratViewer,
  methods: {
    isDisplayed(value: string): boolean {
      if (this.contrat.id < 0 && value == 'CONTRAT_VIEWER') {
        this.setExtended(new Extended('CONTRAT_VIEWER', this.fiche, true));
      }
      return true;
    }
  }
})

</script>
